<div class="h-[100%] bg-gray-50 py-6 faq-scroll-hide">
  <div class="mx-auto w-full min-w-screen-m max-w-screen-2xl px-4 sm:px-6 md:px-8 lg:px-8 xl:px-16 2xl:px-24 xl:pb-8">
    <h1 class="text-2xl md:text-3xl font-bold text-gray-800 mb-8">FAQs</h1>
    <div class="flex flex-col gap-4">

      <div id="faq-section-{{i}}" *ngFor="let faq of faqs; let i = index" class="bg-white border border-gray-300 rounded-lg overflow-hidden transition-shadow shadow-sm hover:shadow-md">
        <button (click)="toggleCard(i)" id="faq-section-{{i}}-button" class="w-full flex justify-between items-center px-3 py-2 focus:outline-none text-left bg-[#E5E1D7]">
          <span class="text-base md:text-lg font-semibold text-gray-800">{{ faq.question }}</span>
          <i [class]="'pi ' + (expandedIndexes.has(i) ? 'pi-chevron-up' : 'pi-chevron-down') + ' text-gray-700 text-lg ml-2'"></i>
        </button>
        <div *ngIf="expandedIndexes.has(i) && !faq.hasLink" class="px-3 pb-3 pt-2 text-gray-700 text-sm md:text-base animate-fade-in whitespace-pre-line" style="overflow: visible;">
          {{ faq.answer }}
        </div>
        <div *ngIf="expandedIndexes.has(i)  && faq.hasLink" class="px-3 pb-3 pt-2 text-gray-700 text-sm md:text-base animate-fade-in" style="overflow: visible;">
          <span [innerHTML]="faq.answer"></span>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
@keyframes fade-in {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fade-in 0.2s ease;
}
.faq-scroll-hide {
  overflow-y: auto;
}
</style>